<template>
    <div class="requests-info">
        <div>
            <div class="section-title">{{formData[0].job_type}} Job Details</div>
            <div class="details gray-bg">
                <div class="field padded-bottom-border">
                    <div class="control">
                        <div class="columns">
                            <div class="column is-4">
                                <label>Job No.</label>
                                <div class='formfield'>
                                    {{formData[0].job_no}}
                                </div>
                            </div>
                            <div class="column is-4">
                                <label>Service Date</label>
                                <div class='formfield'>
                                    {{formData[0].service_date}}
                                </div>
                            </div>
                            <div class="column is-4">
                                <label>Service Time</label>
                                <div class='formfield'>
                                    {{formData[0].service_time}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="field padded-bottom-border">
                    <div class="control">
                        <div class="columns">
                            <div class="column is-6">
                                <label>Target Language</label>
                                <div class='formfield'>
                                    {{formData[0].language}}
                                </div>
                            </div>
                            <div class="column is-6">
                                <label>Service Description</label>
                                <div class='formfield'>
                                    {{formData[0].service_description}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="field padded-bottom-border">
                    <div class="control">
                        <div class="columns">
                            <div class="column is-4">
                                <label>Case Name/LEP</label>
                                <div class='formfield'>
                                    {{formData[0].case_name_lep}}
                                </div>
                            </div>
                            <div class="column is-4">
                                <label>Case No./MRN</label>
                                <div class='formfield'>
                                    {{formData[0].case_num_mrn}}
                                </div>
                            </div>
                            <div class="column is-4">
                                <label>Facilitator</label>
                                <div class='formfield'>
                                    {{formData[0].contact_name}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- loop through the vendor payments array -->
                <div v-for="(rate, index) in vendorPayment">
                    <div v-if="rate.rate != 0" class="field padded-bottom-border">
                        <div class="control">
                            <div class="columns">
                                <div class="column is-12">
                                    <label>{{rate.rate_type_name}}</label>
                                    <div class='formfield'>
                                        {{rate.details}}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="field padded-bottom-border">
                    <div class="control">
                        <div class="columns">
                            <div class="column is-12">
                                <label>Cancellation Policy</label>
                                <div class='formfield'>
                                    {{formData[0].cancellation_policy}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="field">
                    <div class="control">
                        <div class="columns">
                            <div class="column is-12">
                                <label>Special Instructions</label>
                                <div class='formfield'>
                                    {{formData[0].special_instructions}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'

export default {
    data () {
        return {
        }
    },

    computed: {
        ...mapState('requests', {
            formData: state => state.formData,
            remarksData: state => state.remarksData,
            vendorPayment: state => state.vendorPayment,
        }),

        ...mapGetters('requests', {
            statusClass: 'getStatus',
            showNotes: 'getShowCancelNotes',
            showCancel: 'getShowCancelRequest',
            notes: 'getNotes',
            jobType: 'getJobType',
        }),

        ...mapState('nav', {
            activeInfoButton: state => state.activeInfoButton,
        }),

        ...mapState('user', {
            user: state => state.user,
        }),
    },

    methods: {
        displayContents(activeName, name) {
            var scroll = VueStore.state.nav.scrollTop;
            if(scroll){
                this.scrollToTop();
            }
            return activeName === name;
        },

        enableSubmitCancel(){
            VueStore.dispatch('cancelRequest/setShowButton', {key: 'canCancel', bool: true});
            // disable row selection
            VueStore.dispatch('cancelRequest/setShowButton', {key: 'allowRowSelection', bool: false});
        },

        update(key, value){
            if(key === 'remark_notes' && value === ''){
                //disable submit button
            VueStore.dispatch('cancelRequest/setShowButton', {key: 'canCancel', bool: false});
                //console.log('cancel notes is blank')
            } else {
                this.enableSubmitCancel();
                VueStore.dispatch('cancelRequest/updateSelectedData', {key: key, value: value});
            }
        },

        scrollToTop: function(){
            var page = document.getElementById('requests_left');
            page.scrollTop = 0;
        }
    },

    mounted(){
    },

    created(){

    }

}
</script>

<style scoped>
</style>
